import { Attachment, ImageOutput, image as imageUtil } from "core/shared";
import placeholder from "~/assets/images/placeholder-image.png";

type ImageProps = {
  image: string | ImageOutput | Attachment;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  options?: {
    w?: number;
    h?: number;
    q?: number;
    fm?: string;
  };
};

export function Image({
  image,
  alt,
  width,
  height,
  className,
  options,
}: ImageProps) {
  if (!image) return null;

  // If image has multiple sizes (ImageOutput), use srcSet
  if (
    typeof image === "object" &&
    "small" in image &&
    "medium" in image &&
    "large" in image &&
    "original" in image
  ) {
    const variants = Object.keys(image) as (keyof ImageOutput)[];
    const urls = variants.reduce(
      (acc, key) => {
        const variant = image[key];
        acc[key] = imageUtil(variant.url, {
          ...options,
          w: variant.width,
          h: variant.height,
        });
        return acc;
      },
      {} as Record<keyof ImageOutput, string>,
    );

    return (
      <img
        src={urls.original || placeholder}
        alt={alt}
        className={className}
        width={width}
        height={height}
        srcSet={Object.entries(urls)
          .map(([key, url]) => `${url || placeholder} ${image[key].width}w`)
          .join(", ")}
        sizes="(max-width: 768px) 100vw, (max-width: 1024px) 75vw, 50vw"
      />
    );
  }

  const url = imageUtil(image, { ...options });

  return (
    <img
      src={url}
      alt={alt}
      className={className}
      width={width}
      height={height}
    />
  );
}
